// Controle de horas (30/10/2026): timer por tarefa, apontamentos, histórico e escalas de trabalho.
export default {
  hours: {
    title: 'Horas',
    subtitle: 'Apontamentos de horas por cliente, projeto e tarefa.',
    new: 'Apontar horas',
    total: 'Total no período: {time} em {n} apontamentos',
    totalPending: ' · {time} aguardando aprovação',
    empty: 'Nenhuma hora apontada neste período.',
    filters: { customer: 'Cliente', project: 'Projeto', person: 'Pessoa', from: 'De', to: 'Até' },
    columns: { date: 'Data', person: 'Pessoa', customer: 'Cliente', task: 'Tarefa', description: 'Descrição', duration: 'Duração' },
    running: 'Em andamento',
    autoPaused: 'Pausa automática',
    extra: {
      pending: 'Fora do expediente · aguardando aprovação',
      approved: 'Fora do expediente · aprovada',
      rejected: 'Fora do expediente · recusada',
      minutes: '{time} fora do expediente',
      notice: 'Fora do expediente: essas horas só contam depois que um gestor aprovar.',
      noticeSaved: '{time} ficaram fora do expediente e aguardam a aprovação de um gestor.',
      by: 'Por {name}',
    },
    tabs: { mine: 'Horas', packages: 'Pacotes', approval: 'Aguardando aprovação' },
    packages: {
      title: 'Pacotes de horas',
      new: 'Novo pacote',
      empty: 'Nenhum pacote de horas neste cliente.',
      emptyText: 'Cadastre as horas contratadas (ex.: 40 h) para acompanhar o saldo e onde elas foram.',
      overviewEmpty: 'Nenhum pacote de horas cadastrado.',
      overviewEmptyText: 'Abra um cliente, na aba Horas, e cadastre as horas contratadas.',
      notCurrent: 'Fora do período',
      period: '{from} a {to}',
      noPeriod: 'Sem período: conta todas as horas do cliente',
      used: '{used} de {total} ({percent}%)',
      balance: 'Saldo: {time}',
      over: 'Estourou {time}',
      pending: '{time} aguardando aprovação',
      byTask: 'Onde foram as horas, por tarefa',
      byPerson: 'Por pessoa',
      dialogNew: 'Novo pacote de horas',
      dialogEdit: 'Editar pacote de horas',
      fields: {
        title: 'Nome do pacote',
        hours: 'Horas contratadas',
        hoursHint: 'Ex.: 40, 40,5 ou 40:30',
        periodHint: 'Período (opcional): sem datas, conta todas as horas cobráveis do cliente.',
        periodStart: 'Início',
        periodEnd: 'Fim',
        notes: 'Observações',
      },
      confirmDelete: 'Excluir o pacote "{name}"?',
      confirmDeleteText: 'Só o pacote sai; as horas apontadas do cliente continuam.',
      columns: { customer: 'Cliente', package: 'Pacote', period: 'Período', used: 'Usado', balance: 'Saldo' },
      customerTab: 'Horas',
      pdf: 'Ver PDF',
      sendEmail: 'Enviar por e-mail',
    },
    approval: {
      empty: 'Nenhuma hora aguardando aprovação.',
      approve: 'Aprovar',
      reject: 'Recusar',
      approved: 'Horas aprovadas.',
      rejected: 'Horas recusadas.',
      rejectTitle: 'Recusar as horas fora do expediente',
      noteLabel: 'Motivo (a pessoa recebe)',
      approveTitle: 'Aprovar as horas fora do expediente',
      approveNoteLabel: 'Observação (opcional)',
      extraColumn: 'Fora do expediente',
    },
    notBillable: 'Não cobrada',
    hidden: 'Oculta ao cliente',
    source: { timer: 'Timer', manual: 'Manual', granola: 'Granola' },
    dialog: { new: 'Apontar horas', edit: 'Editar apontamento' },
    fields: {
      customer: 'Cliente',
      project: 'Projeto (opcional)',
      description: 'O que foi feito',
      startedAt: 'Início',
      duration: 'Duração (horas:minutos)',
      durationHint: 'Ex.: 1:30 ou 90',
      billable: 'Conta no pacote de horas do cliente',
      visible: 'Aparece no relatório do cliente',
    },
    timer: {
      start: 'Iniciar timer',
      startTitle: 'Iniciar o timer',
      pause: 'Pausar',
      resume: 'Retomar',
      stop: 'Encerrar',
      other: 'Iniciar em outra tarefa (encerra o timer atual)',
      paused: 'Pausado',
      play: 'Começar',
      task: 'Tarefa',
      taskHint: 'O timer sempre conta numa tarefa.',
      taskEmpty: 'Nenhuma tarefa encontrada',
      taskNew: 'Criar tarefa nova',
      taskExisting: 'Escolher tarefa existente',
      newTitle: 'Título da nova tarefa',
      customer: 'Cliente',
      project: 'Projeto (opcional)',
      description: 'O que você vai fazer (opcional)',
      stopped: 'Horas registradas: {time}.',
    },
    taskPlay: 'Iniciar timer nesta tarefa',
    taskNeedsCustomer: 'Para contar horas, vincule um cliente ou um projeto a esta tarefa.',
    taskTab: {
      title: 'Horas',
      total: 'Total na tarefa: {time}',
      totalPending: ' · {time} aguardando aprovação',
      empty: 'Nenhuma hora apontada nesta tarefa ainda.',
      when: 'Quando',
      person: 'Pessoa',
      duration: 'Duração',
      autoPausedHint: 'Pausado automaticamente no fim do expediente',
    },
    report: {
      emailTitle: 'Enviar o relatório de horas',
      to: 'Para',
      cc: 'Cópia',
      subject: 'Assunto',
      body: 'Mensagem',
      signature: 'A assinatura e o PDF vão junto.',
      send: 'Enviar',
      viaGmail: 'Vai pelo seu Gmail.',
      sent: 'Relatório enviado para {to}.',
      sentGmail: 'Relatório enviado pelo seu Gmail para {to}.',
      pdfError: 'Não foi possível gerar o PDF.',
    },
    confirmDelete: 'Excluir este apontamento?',
    saved: 'Apontamento salvo.',
  },
  workSchedules: {
    title: 'Escalas de trabalho',
    subtitle: 'Os horários em que o timer conta horas. Cada colaborador tem uma escala; quem não tem usa a padrão.',
    new: 'Nova escala',
    default: 'padrão',
    makeDefault: 'Usar como padrão (já vem selecionada em novos colaboradores)',
    empty: 'Nenhuma escala cadastrada. Sem escala, vale segunda a sexta, 08:00–12:00 e 13:00–18:00.',
    employees: '{n} colaboradores',
    weekly: '{time} por semana',
    dayOff: 'Folga',
    addInterval: 'Adicionar intervalo',
    removeInterval: 'Remover intervalo',
    dialogNew: 'Nova escala',
    dialogEdit: 'Editar escala',
    fields: { name: 'Nome', start: 'Início', end: 'Fim' },
    weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
    confirmDelete: 'Excluir a escala "{name}"? Os colaboradores nela passam a usar a escala padrão.',
    invalid: 'Confira os horários: o fim deve ser depois do início e os intervalos não podem se sobrepor.',
  },
}
